import Downloads from "./Downloads";
import { connect } from "react-redux";

function mapStateToProps(state) {
  return {
    loading: state.coursesList.loading,
  };
}

export default connect(mapStateToProps)(Downloads);
